'use client';

import { useState, useEffect } from 'react';

type BrowserWindow = Window &
    typeof globalThis & {
        OnetrustActiveGroups?: string;
        _satellite?: {
            getVar: (key: string) => string | string[] | boolean | null;
        };
    };

function resolveConsent(): boolean {
    if (typeof window === 'undefined') return false;

    const browserWindow = window as BrowserWindow;

    try {
        if (
            typeof browserWindow._satellite !== 'undefined' &&
            typeof browserWindow._satellite.getVar === 'function'
        ) {
            if (browserWindow._satellite.getVar('core:cc:isKidsPage')) return false;

            const globalPageName = browserWindow._satellite.getVar('core:cc:globalPageName');
            if (
                globalPageName === 'www:help/app-us-en' ||
                (typeof globalPageName === 'string' &&
                    globalPageName.toLowerCase() === 'www:privacy-policy')
            ) return false;
        }
    } catch (err) {
        console.warn('[useConsent] _satellite check failed:', err);
    }

    if (window.location.pathname === '/help/app/us-en') return false;

    const activeGroups = browserWindow.OnetrustActiveGroups ?? '';
    return activeGroups.includes('C0004');
}

export function useConsent(): boolean {
    const [consentGranted, setConsentGranted] = useState<boolean>(() => {
        return resolveConsent();
    });

    useEffect(() => {
        const handler = () => setConsentGranted(resolveConsent());
        window.addEventListener('oneTrustConsentChanged', handler);
        return () => window.removeEventListener('oneTrustConsentChanged', handler);
    }, []);

    return consentGranted;
}